import React from "react";
import { ContentPage } from 'modules2/content-page';
import {SearchCard} from "./components";
import container from "./SearchPage.container";

const SearchPage = (props) => {
    const { query, results } = props.searchRadioState;
    const totalResult = Object.keys(results).length;
    return(
        <ContentPage
            header={{
                title: `Search results (${totalResult})`,
                description: `${query}`,
                controls: ''
            }}
            body={<SearchCard />}
        />
    );
};

export default container(SearchPage);